import Header from "components/Headers/Header";
import IntroductionTalkingBadge from "components/IntroductionTalkingBadge";
import ReuseableTable from "components/Tables/ReuseableTable";
import TalkingBadgeAddModal from "components/TalkingBadgeAddModal";
import TalkingEditModal from "components/TalkingEditModal";
import WelcomeScreen from "components/WelcomeScreen";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
  Spinner,
} from "reactstrap";
import { deleteTalkingBadge } from "store/actions/talkingBadgeAction";
import { getTalkingBadge } from "store/actions/talkingBadgeAction";
import talkingBadgesWelcomeImage from "../../assets/img/custom/talkingbadges_preview.png";
import image2 from "../../assets/img/custom/addvideoImge.png";
import { Rating } from "@mui/material";
import { updateRatingData } from "store/actions/talkingBadgeAction";
import { addStrategyRating } from "store/actions/SeasonActions";
import firebase from "../../config/firebase";

const TalkingBadges = () => {
  const dispatch = useDispatch();
  const { talkingBadge, isAddLoading, lastDocument, hasMoreDocument } =
    useSelector((state) => state.talkingBadges);
  const { uid, user } = useSelector((state) => state.auth);
  const [addModal, setAddModal] = useState(false);
  const [addModal1, setAddModal1] = useState(false);
  const [badgeData, setBadgeData] = useState(null);
  const [editData, setEditData] = useState(null);
  const [handleContinue, setHandleContinue] = useState(false);
  const [loadMoreLoader, setLoadMoreLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [managerEmail, setManagerEmail] = useState("");
  const [ratingModal, setRatingModal] = useState(false);
  const [strategyRating, setStrategyRating] = useState(false);
  const [selectedRating, setSelectedRating] = useState(0);
  const [selectedStrategyRating, setSelectedStrategyRating] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [remarks, setRemarks] = useState("");
  const [strategyRemarks, setStrategyRemarks] = useState("");
  const [docId, setDocId] = useState("");
  const [ratingBtnLoader, setRatingBtnLoader] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

  const toggleRatingModal = () => {
    setRatingModal(!ratingModal);
    setSelectedRating(0);
    setSelectedStrategyRating(0);
    setSelectedOption("");
    setRemarks("");
    setStrategyRemarks("");
    setStrategyRating(false);
  };

  const handleRatingSubmit = (e) => {
    e.preventDefault();
    const ratingData = {
      rating: selectedRating,
      satisfactory: selectedOption,
      remarks: remarks,
      managerRating: true,
    };
    if (selectedRating == "") {
      toast.warning("Please Give Review Rating");
    } else if (selectedOption == "") {
      toast.warning("Please Give Review Satisfied Or Unsatisfied");
    } else {
      setRatingBtnLoader(true);
      dispatch(
        updateRatingData(ratingData, docId, () => {
          if (strategyRating) {
            dispatch(
              addStrategyRating({
                athleteName: user.first_name + " " + user.last_name,
                athleteId: user.athleteID,
                athleteEmail: user.email,
                strategyRating: selectedStrategyRating,
                strategyRemarks: strategyRemarks,
                managerEmail: managerEmail,
                docId: docId,
                createdAt: firebase.firestore.Timestamp.now(),
              })
            );
          }
          toast.success("Add Manager Rating Successfully");
          setRatingBtnLoader(false);
          toggleRatingModal();
          setSelectedRating(0);
          setSelectedStrategyRating(0);
          setSelectedOption("");
          setRemarks("");
          setStrategyRemarks("");
        })
      );
    }
  };

  const toggle = () => {
    setAddModal(!addModal);
  };
  const toggle1 = () => {
    setAddModal1(!addModal1);
  };

  const deleteBadge = (id) => {
    setDeleteLoader(true);
    dispatch(
      deleteTalkingBadge(id, () => {
        toast.success("Badge Deleted Successfully");
        dispatch(
          getTalkingBadge(uid, "", [], () => {
            setIsLoading(false);
            setDeleteLoader(false);
            toggleDeleteModal();
          })
        );
      })
    );
  };

  const handleLoadMore = () => {
    setLoadMoreLoader(true);
    dispatch(
      getTalkingBadge(uid, lastDocument, talkingBadge, () => {
        setLoadMoreLoader(false);
      })
    );
  };

  const columns = ["CREATED AT", "Price", "Preview IMAGE", "Full VIDEO"];

  const keyMap = {
    "CREATED AT": "createdAt",
    Price: "amount",
    "Preview IMAGE": "introductionImage",
    "Full VIDEO": "appealingVideo",
  };

  const renderActions = (item) => {
    return (
      <>
        <Button
          size="sm"
          color="primary"
          className="px-3 m-1 "
          onClick={() => {
            setEditData(item);
            toggle1();
          }}
        >
          Edit
        </Button>
        <Button
          size="sm"
          color="danger"
          className="m-1"
          disabled={isAddLoading == true}
          onClick={() => {
            setDocId(item.id);
            toggleDeleteModal();
          }}
        >
          Delete
        </Button>
        {item.managerEmail && (
          <Button
            size="sm"
            color="success"
            className="m-1 text-nowrap"
            disabled={item.managerRating}
            onClick={() => {
              toggleRatingModal();
              setDocId(item.id);
              setManagerEmail(item.managerEmail);
            }}
          >
            Manager Rating
          </Button>
        )}
      </>
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const TalkingBadgesContent = () => {
    return (
      <>
        <div className="border border-dark">
          <h1
            className="font-weight-bolder text-center"
            style={{ fontSize: isSmallScreen ? "13px" : "26px" }}
          >
            TALKING BADGES​ TIPS/VIDEO FOR ATHLETES
          </h1>
        </div>
        <p className="font-weight-normal mt-2">
          You can&nbsp;
          <b className="text-danger">
            REALLY BE CREATIVE in selecting how you put together&nbsp;
          </b>
          <b className="text-primary">YOUR&nbsp;</b>
          series of&nbsp;
          <b className="text-primary">
            TALKING BADGES. Fans will ENJOY.​&nbsp;
          </b>
        </p>
        <p className="font-weight-normal mt-2">
          These&nbsp;
          <b className="text-dark ">
            T.B.s&nbsp; at{" "}
            <b>
              <b className="text-dark">Fans</b>
              <b className="text-primary">Help</b>
              <b className="text-danger">Players</b>
            </b>{" "}
          </b>
          can be of two types:&nbsp;
          <b className="text-danger">a diary entry</b>
          &nbsp;made by&nbsp;
          <b className="text-danger">YOUR FAVORITE Student Athlete,</b>
          &nbsp;
          <b className="text-primary">or a video selected FOR HUMOR AND FUN</b>
          &nbsp; by the Student Athlete for you, i.e., his or her fans.​
        </p>

        <p className="font-weight-normal mt-2">
          HERE’S another important thing to Remember– up to{" "}
          <b className="text-dark ">
            <b className="text-danger">88%</b> of the money{" "}
            <b className="text-dark">F</b>
            <b className="text-primary">H</b>
            <b className="text-danger">P</b> spend at FHP goes{" "}
            <b className="text-danger">
              <u> directly to Student Athletes.</u>
            </b>
          </b>
        </p>
        <p className="font-weight-normal mt-2">
          <b className="text-dark">THANK YOU!</b>{" "}
          <u className="text-dark">Enjoy</u> and{" "}
          <b className="text-dark">
            <u>TELL YOUR FRIENDS.</u>
          </b>
        </p>
      </>
    );
  };

  const youtubeLink = "https://www.youtube.com/watch?v=UjNrz3IO-Do";

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      getTalkingBadge(uid, "", [], () => {
        setIsLoading(false);
      })
    );
  }, []);

  const [photoModal, setPhotoModal] = useState(false);
  const togglePhotoModal = () => {
    setPhotoModal(!photoModal);
  };

  return (
    <>
      <Header />

      {handleContinue ? (
        <>
          <Container fluid>
            <IntroductionTalkingBadge />
            <Card className="p-3 mt-3 mb-8">
              <div className="d-flex justify-content-end align-items-center px-4 mb-3" style={{ gap: "12px" }}>
                <Button
                  color="info"
                  outline
                  className="p-0 d-flex align-items-center justify-content-center"
                  style={{ width: "36px", height: "36px", borderRadius: "6px" }}
                  onClick={togglePhotoModal}
                >
                  <i className="fas fa-info" style={{ fontSize: "15px" }}></i>
                </Button>
                <Button
                  onClick={toggle}
                  color="primary"
                >
                  Create Badge
                </Button>
              </div>
              {isLoading ? (
                <Row className="justify-content-center">
                  <Spinner size="sm" />
                </Row>
              ) : (
                <>
                  <ReuseableTable
                    columns={columns}
                    data={talkingBadge?.map((contest) => ({
                      ...contest,
                      createdAt: moment
                        .unix(contest?.createdAt?.seconds)
                        .format("D MMM YYYY"),
                      amount: contest?.amount,
                      introductionImage: (
                        <img
                          src={contest.introducingImageUrl}
                          className="cursor-pointer"
                          width={"50px"}
                        />
                      ),
                      appealingVideo: (
                        <img
                          src={contest.appealingVideoUrl}
                          className="cursor-pointer"
                          width={"50px"}
                        />
                      ),
                    }))}
                    keyMap={keyMap}
                    renderActions={renderActions}
                  />

                  {!isLoading && (
                    <div className="w-100  p-3 d-flex justify-content-center">
                      {talkingBadge && talkingBadge?.length >= 5 && (
                        <Button
                          color="primary"
                          onClick={handleLoadMore}
                          disabled={!hasMoreDocument || loadMoreLoader}
                        >
                          {loadMoreLoader ? (
                            <Spinner size={"sm"} />
                          ) : (
                            "Load More"
                          )}
                        </Button>
                      )}
                    </div>
                  )}
                </>
              )}
            </Card>
          </Container>

          <TalkingBadgeAddModal
            toggle={toggle}
            addModal={addModal}
            setBadgeData={setBadgeData}
          />
          <TalkingEditModal
            toggle={toggle1}
            addModal={addModal1}
            badgeData={editData}
          />
        </>
      ) : (
        <Container>
          <Row>
            <WelcomeScreen
              setHandleContinue={setHandleContinue}
              content={TalkingBadgesContent}
              welcomeImage={talkingBadgesWelcomeImage}
              youtubeLink={youtubeLink}
            />
          </Row>
        </Container>
      )}
      <Modal isOpen={photoModal} toggle={togglePhotoModal} size="lg">
        <Container className="text-center ">
          <img src={image2} alt="" width="100%" />
        </Container>
        <div className="d-flex justify-content-end align-items-end mb-2 mr-4">
          <Button color="primary" onClick={togglePhotoModal}>
            Ok
          </Button>
        </div>
      </Modal>
      <Modal isOpen={ratingModal} toggle={toggleRatingModal} centered>
        <Form onSubmit={handleRatingSubmit}>
          <Container className="text-center p-5">
            <h4 className="mb-4">Rate this Badge</h4>
            <Row className="justify-content-center">
              <Rating
                required
                value={selectedRating}
                onChange={(event, newValue) => {
                  setSelectedRating(newValue);
                }}
                stars={3}
              />
            </Row>
            <Row>
              <FormGroup>
                <Label for="radioButtons">Choose an option:</Label>
                <div>
                  <Col lg="4">
                    <Label check>
                      <Input
                        type="radio"
                        name="radioOptions"
                        value="Satisfied"
                        checked={selectedOption === "Satisfied"}
                        onChange={(e) => setSelectedOption(e.target.value)}
                      />
                      Satisfied
                    </Label>
                  </Col>
                  <Col lg="4">
                    <Label check>
                      <Input
                        type="radio"
                        name="radioOptions"
                        value="Unsatisfied"
                        checked={selectedOption === "Unsatisfied"}
                        onChange={(e) => setSelectedOption(e.target.value)}
                      />
                      Unsatisfied
                    </Label>
                  </Col>
                </div>
              </FormGroup>
            </Row>
            <FormGroup>
              <Label for="remarks">Remarks</Label>
              <Input
                required
                type="textarea"
                name="remarks"
                id="remarks"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </FormGroup>
            <Row className="mt-0 mb-3">
              <Col>
                <Label>You want to give strategy Rating:</Label>
              </Col>
              <Col>
                <div>
                  <p className="edit-password-info">
                    <div className="switchBtnContainer">
                      <div
                        className="switchBtn"
                        style={{
                          backgroundColor: strategyRating
                            ? "#4caf50"
                            : "#f44336",
                        }}
                        onClick={() => setStrategyRating(!strategyRating)}
                      >
                        <div
                          className="switchBtnSlider"
                          style={{
                            left: strategyRating ? "26px" : "2px",
                          }}
                        ></div>
                      </div>
                      <span className="switchBtnLabel">
                        {strategyRating ? "Yes" : "No"}
                      </span>
                    </div>
                  </p>
                </div>
              </Col>
            </Row>
            {strategyRating && (
              <>
                <h4 className="mb-4">Strategy Rating For Manager</h4>
                <Row className="justify-content-center">
                  <Rating
                    value={selectedStrategyRating}
                    onChange={(event, newValue) => {
                      setSelectedStrategyRating(newValue);
                    }}
                    stars={3}
                  />
                </Row>
                <FormGroup>
                  <Label for="strategy-remarks">Strategy Remarks</Label>
                  <Input
                    required
                    type="textarea"
                    name="strategy-remarks"
                    id="strategy-remarks"
                    value={strategyRemarks}
                    onChange={(e) => setStrategyRemarks(e.target.value)}
                  />
                </FormGroup>
              </>
            )}
            <Button color="primary" type="submit" disabled={ratingBtnLoader}>
              {ratingBtnLoader ? <Spinner size="sm" /> : "Submit Rating"}
            </Button>
            <Button color="danger" onClick={toggleRatingModal}>
              Cancel
            </Button>
          </Container>
        </Form>
      </Modal>

      <Modal isOpen={deleteModal} centered toggle={toggleDeleteModal}>
        <ModalBody>
          <div className="text-center">
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to Delete.
            </span>
            <br />
            <br />
            <br />
            <Button color="primary" onClick={toggleDeleteModal}>
              Cancel
            </Button>{" "}
            <Button color="danger" onClick={() => deleteBadge(docId)}>
              {deleteLoader ? <Spinner size="sm" /> : "Delete"}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default TalkingBadges;
